import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'common/components/modules/modal';
import Button from 'common/components/elements/buttons/primary';

function Limit({
   title,
   description,
   onCancel,
   isMobile,
   animate,
}) {
   return (
      <Modal
         onClose={ onCancel }
         roundedModal='lg'
         contentPosition={ isMobile ? 'bottom' : 'center' }
         animate={ isMobile ? animate : null }
         isCloseAction={ false }
      >
         <div className='flex flex-col items-center px-3 py-5'>
            {
               title && (
                  <span className='text-major dark:text-major-dark text-center text-xl font-bold leading-normal block mt-2'>
                     {title}
                  </span>
               )
            }
            <span className='text-center text-secondary dark:text-secondary-dark leading-tight block mt-4'>
               { description }
            </span>
            <div className='h-9 mt-3'>
               <Button
                  text='Ok'
                  padding='none'
                  classNames='h-full px-3'
                  backgroundColor='transparent'
                  primaryColor
                  textSize='base'
                  fontWeight='medium'
                  onClick={ onCancel }
                  waveColor='rgba(106, 106, 106, 0.8)'
               />
            </div>
         </div>
      </Modal>
   );
}

Limit.propTypes = {
   isMobile: PropTypes.bool,
   onCancel: PropTypes.func,
   title: PropTypes.string,
   description: PropTypes.string,
   animate: PropTypes.string,
};
Limit.defaultProps = {
   onCancel: () => {},
};

export default React.memo(Limit);
